import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { Observable, finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { IAddModulTipProgramActivPayload, IModulTipProgramActivForm } from '../module-tipuri-program-active.interface';
import { ModuleTipuriProgramActiveService } from '../module-tipuri-program-active.service';
import { ModuleTipuriProgramService } from '../../module-tipuri-program/module-tipuri-program.service';
import { ModuleService } from '../../module/module.service';

@Component({
    selector: 'app-add-module-tipuri-program-active',
    templateUrl: './add-module-tipuri-program-active.component.html',
    styleUrls: ['./add-module-tipuri-program-active.component.scss']
})
export class AddModuleTipuriProgramActiveComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    modules$!: Observable<Generic[]>;
    programTypes$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        id_modul: new FormControl('', [Validators.required, Validators.min(0)]),
        id_program_type: new FormControl('', [Validators.required, Validators.min(0)]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddModuleTipuriProgramActiveComponent>,
        private moduleTipuriProgramActiveService: ModuleTipuriProgramActiveService,
        private notificationService: NotificationService,
        private moduleTipuriProgramService: ModuleTipuriProgramService,
        private moduleService: ModuleService,
    ) { }

    ngOnInit(): void {
        this.loadModules();
        this.loadProgramTypes();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadModules() {
        this.isLoading = true;
        this.modules$ = this.moduleService.listModule().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    loadProgramTypes() {
        this.isLoading = true;
        this.programTypes$ = this.moduleTipuriProgramService.listModuleTipProgram().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_program_type } = this.form.value as IModulTipProgramActivForm;
        const payload: IAddModulTipProgramActivPayload = {
            id_modul,
            id_program_type
        };

        this.moduleTipuriProgramActiveService
            .addModulTipProgramActiv(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
